import React, { useState } from "react";
import styles from './NewEvaluationForm.module.scss';
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import PropTypes from "prop-types";
import Icon from "../icon/Icon";
import AutoCompleteInstructor from "../autoCompleteInstructor/AutoCompleteInstructor";
import Button from "../button/Button";
import TextField from "../textField/TextField";
import DropDownButton from "../dropDownButton/DropDownButton";

const NewEvaluationForm = ({
  instructorList,
  specialities,
  onCancel,
  onSubmit,
  isLoading
}) => {
  const [instructor, setInstructor] = useState(null);
  const [instructorError, setInstructorError] = useState('');
  const [showCreateInstructor, setShowCreateInstructor] = useState('');
  const [firstName, setFirstName] = useState('');
  const [firstNameError, setFirstNameError] = useState('');
  const [lastName, setLastName] = useState('');
  const [lastNameError, setLastNameError] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const validateInstructor = () => {
    if(!instructor) {
      return 'Instructor is required';
    }
    return '';
  };
  
  const validateFirstName = () => {
    if(!firstName) {
      return 'First Name is required';
    }
    if(!/^[A-Za-z]{2}/.test(firstName)) {
      return 'First Name must contain only letters and be at least 2 characters long.'
    }
    return '';
  }
  
  const validateLastName = () => {
    if(!lastName) {
      return 'Last Name is required';
    }
    if(!/^[A-Za-z]{2}/.test(lastName)) {
      return 'Last Name must contain only letters and be at least 2 characters long.'
    }
    return '';
  }

  const validateEmail = () => {
    if(!email) {
      return 'Email is required';
    }
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(!regex.test(email)) {
      return 'Email is invalid';
    }
    return '';
  };

  const handleStartEvaluation = (selectedSpeciality) => {
    if(showCreateInstructor) {  
      const firstNameValidationResult = validateFirstName();
      const lastNameValidationResult = validateLastName();
      const emailValidationResult = validateEmail();

      setFirstNameError(firstNameValidationResult);
      setLastNameError(lastNameValidationResult);
      setEmailError(emailValidationResult);

      if (firstNameValidationResult || lastNameValidationResult || emailValidationResult) {
        return false;
      }

      onSubmit({
        firstName,
        lastName,
        email,
        specialityId: selectedSpeciality
      });

    } else {
      const instructorValidationResult = validateInstructor();
  
      setInstructorError(instructorValidationResult);

      if(instructorValidationResult) {
        return false;
      }

      onSubmit({
        instructorId: instructor.instructorId,
        specialityId: selectedSpeciality
      })
    }
  };

  const renderEvaluationAction = () => {
    if (specialities && specialities.length > 1) {
      return (
        <DropDownButton
          label="Start Evaluation"
          items={specialities.map(item => ({
            label: item.name,
            onClick: () => {
              handleStartEvaluation(item.id);
            }
          }))}
          position="top"
          size="medium"
        />
      );
    } else {
      return (
        <Button
          label="Start Evaluation"
          onClick={() => {
            if (specialities) {
              handleStartEvaluation(specialities[0]?.id);
            } else {
              handleStartEvaluation(null);
            }
          }}
          size="medium"
        />
      );
    }
  };

  return (
    <form 
      className={styles.form}
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      {isLoading && <LoadingOverlay />}
      <div className={styles.header}>
        <span><Icon name="clipboard" /></span>
        <h3>Create New Evaluation</h3>
      </div>
      {!showCreateInstructor &&<div className={styles.inputContainer}>
        <span className={styles.icon}><Icon name="users" /></span>
        <div className={styles.input}>
          <AutoCompleteInstructor
            label="Instructor’s Email "
            list={instructorList}
            onChange={(instructor) => setInstructor(instructor)}
            error={instructorError}
            onAddNew={(text) => {
              setEmail(text);
              setShowCreateInstructor(true);
            }}
          />
        </div>
      </div>}
      {showCreateInstructor && <div className={styles.createForm}>
        <div className={styles.row}>
          <div className={styles.column}>
            <TextField
              label="First Name"
              value={firstName}
              onChange={(value) => setFirstName(value)}
              error={firstNameError}
            />
          </div>
          <div className={styles.column}>
            <TextField
              label="Last Name"
              value={lastName}
              onChange={(value) => setLastName(value)}
              error={lastNameError}
            />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.column}>
            <TextField
              label="Email"
              type="email"
              value={email}
              onChange={(value) => setEmail(value)}
              error={emailError}
            />
          </div>
          <div className={styles.column}>
          </div>
        </div>
      </div>}
      <div className={styles.actions}>
        <Button
          label="Cancel"
          variant="secondary"
          size="medium"
          onClick={() => {
            if(showCreateInstructor) {
              setShowCreateInstructor(false);
            } else {
              onCancel()
            }
          }}
        />
        {renderEvaluationAction()}
      </div>
    </form>
  );
};

NewEvaluationForm.propTypes = {
  instructorList: PropTypes.arrayOf(
    PropTypes.shape({
      instructorId: PropTypes.number.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      profilePicture: PropTypes.string,
      clinicalSiteId: PropTypes.number.isRequired,
      clinicalSite: PropTypes.string.isRequired,
      speciality: PropTypes.string
    })
  ).isRequired,
  specialities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool
}

export default NewEvaluationForm;